// 路由的全局守卫

// 权限控制逻辑
import router from './index'
import store from '../store/index'
// import {getMyResults, treeDept} from '../store/modules/myUtil'
// import {mapActions} from 'vuex';
//引入nprogress 进度条插件
// import NProgress from 'nprogress'

import { Message } from 'element-ui'
import { fn } from "../store/modules/conglomerate"
// import {getToken} from '@/utils/auth' // 从cookie获取令牌

// 简单配置  进度条
// NProgress.inc(0.2)
// NProgress.configure({easing: 'ease', speed: 500, showSpinner: false})
// console.log(getToken())
// if(!getToken()){
//     //清除
//     localStorage.clear();
// }

const whiteList = ['/', '/home', '/introduction', '/industry', '/notice', '/meeting', '/noticedetail', '/meetingdetail', '/trendsdetail'] //白名单
router.beforeEach(async(to, from, next) => {
    // NProgress.start()
    // console.log('进入路由守卫', to, from);
    //网站标题
    document.title = '云南省妇科医疗质量质控中心';
    //白名单，跳过
    if (whiteList.indexOf(to.path) != -1) {
        localStorage.clear(); //清除缓存
        next();
    } else {
        //判断是否登录
        var token = localStorage.getItem('token');
        if (!token) {
            //跳转登录
            next('/home');
        } else {
            //若用户角色已附加则说明动态路由已经添加
            const hasRoles = store.getters.roles && store.getters.roles.length > 0;
            if (hasRoles) {
                next();
            } else {
                //添加路由
                await store.dispatch('user/getInfo')
                const access = await store.dispatch('permission/generateRoutes');
                router.addRoutes(access);

                // 继续路由切换
                next({...to, replace: true });
            }
        }
    }
})

router.afterEach(() => {
    // NProgress.done()
})